export const supplementalExtraDefaultTranslations = {
  en: {
    "auth.backToHome": "Back to home",
    "auth.backToLogin": "Back to login",
    "auth.continueGoogle": "Continue with Google",
    "auth.enterEmail": "Please enter your email",
    "auth.enterResetToken": "Enter the reset code from your email.",
    "auth.fillAllFields": "Please fill all fields",
    "auth.googleInvalidToken": "Google could not verify this sign-in. Please try again.",
    "auth.googlePopupBlocked": "Your browser blocked the Google sign-in popup.",
    "auth.googleProviderUnavailable": "Google login is unavailable right now.",
    "auth.googleUnauthorizedDomain": "This domain is not authorized for Google login in Firebase.",
    "auth.googleUnavailable": "Google login is not configured yet.",
    "auth.haveAccount": "Already have an account?",
    "auth.invalidResetLink": "This reset link is invalid or expired.",
    "auth.joinUs": "Join Velaris Royal for exclusive benefits.",
    "auth.passwordTooShort": "Password must be at least 6 characters",
    "auth.passwordUpdated": "Password updated successfully",
    "auth.resetDesc": "Enter your email to reset your password.",
    "auth.resetEmailDeliveryFailed": "Unable to send reset email right now.",
    "auth.resetEmailUnavailable": "Password reset email is not configured yet.",
    "auth.resetError": "Failed to reset password",
    "auth.resetPageDescription": "Choose a new password for your Velaris account.",
    "auth.resetPassword": "Reset Password",
    "auth.resetToken": "Reset Code",
    "auth.resettingPassword": "Resetting password...",
    "auth.sendResetLink": "Send Reset Link",
    "auth.signInRequired": "Please sign in to save favorites.",
    "auth.signInWithNewPassword": "Sign in with your new password to continue.",
    "auth.welcomeBack": "Welcome back! Please sign in to continue.",
    "badges.offer": "Offer",
    "badges.exclusive": "Exclusive",
    "badges.new": "New",
    "badges.discount": "Discount",
    "carDetail.basedOn": "Based on",
    "carDetail.browseAll": "Browse all cars",
    "carDetail.clickToZoom": "Click to zoom",
    "carDetail.comment": "Comment",
    "carDetail.delivery": "Free Delivery & Pickup",
    "carDetail.description": "Description",
    "carDetail.doors": "Doors",
    "carDetail.engine": "Engine",
    "carDetail.features": "Features",
    "carDetail.featuresComingSoon": "Features information coming soon.",
    "carDetail.from": "from",
    "carDetail.fuelType": "Fuel Type",
    "carDetail.in": "in",
    "carDetail.inquiryFor": "Inquiry for",
    "carDetail.inquirySent": "Inquiry sent successfully! We'll contact you soon.",
    "carDetail.insurance": "Comprehensive Insurance",
    "carDetail.mileage": "200km daily mileage",
    "carDetail.noDescription": "No description available.",
    "carDetail.noReviews": "No reviews yet. Be the first to share your experience.",
    "carDetail.notFound": "Car Not Found",
    "carDetail.power": "Power",
    "carDetail.rating": "Rating",
    "carDetail.rent": "Rent",
    "carDetail.rentalRequirements": "Tell us about your rental requirements...",
    "carDetail.req1": "Valid UAE driving license or International Driving Permit",
    "carDetail.req2": "Minimum age: 25 years",
    "carDetail.req3": "Security deposit",
    "carDetail.req4": "Valid passport copy",
    "carDetail.req5": "Credit card authorization",
    "carDetail.reviewError": "Failed to submit your review.",
    "carDetail.reviewSubmitted": "Review submitted successfully!",
    "carDetail.reviews": "Reviews",
    "carDetail.reviewsCount": "reviews",
    "carDetail.roadside": "24/7 Roadside Assistance",
    "carDetail.seats": "Seats",
    "carDetail.shareExperience": "Share your experience before submitting.",
    "carDetail.similar": "Similar",
    "carDetail.specs": "Specifications",
    "carDetail.submitReview": "Submit Review",
    "carDetail.transmission": "Transmission",
    "carDetail.vehicles": "Vehicles",
    "carDetail.whatsIncluded": "What's Included",
    "carDetail.writeReview": "Write a Review",
    "carDetail.yourReview": "Your Review",
    "common.linkCopied": "Link copied to clipboard!",
    "contact.qrDescription": "Scan this QR code to open our preferred contact channel instantly on your phone. Replace the configured QR value later if you want it to point to a landing page or downloadable vCard.",
    "contact.qrEyebrow": "Scan & Connect",
    "contact.qrHint": "Current QR destination",
    "contact.qrTitle": "Save our details in one scan",
    "contact.whatsappCarPrefill": "Hi! I'm interested in renting the {car}. Please provide more details.",
    "contact.whatsappGeneralPrefill": "Hello! I'm interested in renting a car from Velaris Royal.",
    "cta.subtitle": "Browse our premium collection and find your perfect ride. Book now and enjoy the royal treatment.",
    "favorites.added": "Added to favorites.",
    "favorites.removed": "Removed from favorites.",
    "favorites.updateError": "Failed to update favorites.",
    "footer.aboutFallback": "Premium car rental services in the UAE. Experience luxury and comfort with our extensive fleet of vehicles.",
    "footer.backToTop": "Back to top",
    "form.confirmPassword": "Confirm Password",
    "form.newPassword": "New Password",
    "header.followUs": "Follow Us",
    "home.heroFallbackSubtitle": "Discover the finest collection of luxury, sports, and premium vehicles for rent across the UAE.",
    "home.statsCarsAvailable": "Cars Available",
    "home.statsHappyCustomers": "Happy Customers",
    "home.statsPartnerSuppliers": "Partner Suppliers",
    "home.statsCitiesCovered": "Cities Covered",
    "home.featureInsuredTitle": "Fully Insured",
    "home.featureInsuredDescription": "All vehicles come with comprehensive insurance coverage",
    "home.featureSupportTitle": "24/7 Support",
    "home.featureSupportDescription": "Round-the-clock customer support for your convenience",
    "home.featureFleetTitle": "Premium Fleet",
    "home.featureFleetDescription": "Latest models from world-renowned luxury brands",
    "home.featurePricesTitle": "Best Prices",
    "home.featurePricesDescription": "Competitive rates with no hidden fees guaranteed",
    "listings.pageDescription": "Browse and rent luxury, sports, and economy cars in Dubai, Abu Dhabi, and across UAE. Compare prices from top suppliers and book instantly.",
    "loyalty.tier.bronze": "Bronze",
    "loyalty.tier.silver": "Silver",
    "loyalty.tier.gold": "Gold",
    "loyalty.tier.platinum": "Platinum",
    "nav.offers": "Offers",
    "offers.browseFleet": "Need More Options?",
    "offers.emptyDescription": "Check again soon or browse the full fleet for the latest luxury rentals.",
    "offers.emptyEyebrow": "Offer",
    "offers.emptyTitle": "No offers available right now",
    "offers.heroDescription": "Explore every active campaign, compare limited-time deals, and jump directly into discounted luxury rentals.",
    "offers.heroEyebrow": "Offer",
    "offers.heroTitle": "All Current Offers",
    "offers.loadError": "The offers page could not be loaded right now.",
    "offers.loading": "Loading offers...",
    "offers.pageDescription": "Browse all active luxury car rental offers, promotions, and limited-time deals from Velaris Royal.",
    "offers.pageTitle": "Offers | Velaris Royal Car Rental",
    "offers.sectionSubtitle": "Available Now",
    "offers.sectionTitle": "All Offers",
    "offers.totalCars": "Discounted Cars",
    "offers.totalOffers": "Active Offers",
    "partners.becomePartnerDesc": "Join our network of premium partners and connect with discerning customers seeking luxury automotive experiences.",
    "partners.benefitQualityTitle": "Quality Assurance",
    "partners.benefitQualityDescription": "All partners undergo rigorous vetting to ensure the highest standards.",
    "partners.benefitCustomerFirstTitle": "Customer First",
    "partners.benefitCustomerFirstDescription": "Our partners share our commitment to exceptional customer service.",
    "partners.benefitNetworkTitle": "Wide Network",
    "partners.benefitNetworkDescription": "Access to an extensive network of premium services across UAE.",
    "partners.benefitTrustedTitle": "Trusted Integrations",
    "partners.benefitTrustedDescription": "Insurance, payment, and business partners are managed directly from Odoo.",
    "partners.categoryCertification": "Certification",
    "partners.categoryCertificationDesc": "Verified certifications and trust signals maintained from the Odoo CMS.",
    "partners.categoryInsurance": "Insurance Partner",
    "partners.categoryInsuranceDesc": "Trusted coverage and risk-management partners supporting the rental journey.",
    "partners.categoryPartner": "Business Partner",
    "partners.categoryPartnerDesc": "Business partners managed from Odoo and surfaced directly on the website.",
    "partners.categoryPayment": "Payment Partner",
    "partners.categoryPaymentDesc": "Secure payment providers integrated into the Velaris customer experience.",
    "partners.empty": "No active partners were found in Odoo.",
    "partners.loadError": "The partners section could not be loaded from Odoo right now.",
    "partners.loading": "Loading partners from Odoo...",
    "partners.managedInCms": "Managed in Odoo CMS",
    "partners.pageDescription": "Discover our trusted partners in the luxury car rental industry. Premium dealerships, suppliers, and service providers in Dubai and UAE.",
    "pricing.pageDescription": "Compare prices for luxury car rentals in Dubai & UAE. Daily, weekly, and monthly rates for all vehicles.",
    "profile.account": "Account",
    "profile.pointsBalance": "Points Balance"
  },
  ar: {
    "auth.backToHome": "العودة إلى الرئيسية",
    "auth.backToLogin": "العودة إلى تسجيل الدخول",
    "auth.continueGoogle": "المتابعة عبر Google",
    "auth.enterEmail": "يرجى إدخال بريدك الإلكتروني",
    "auth.enterResetToken": "أدخل رمز إعادة التعيين من بريدك الإلكتروني.",
    "auth.fillAllFields": "يرجى تعبئة جميع الحقول",
    "auth.googleInvalidToken": "تعذر على Google التحقق من تسجيل الدخول. حاول مرة أخرى.",
    "auth.googlePopupBlocked": "حظر المتصفح نافذة تسجيل الدخول عبر Google.",
    "auth.googleProviderUnavailable": "تسجيل الدخول عبر Google غير متاح حالياً.",
    "auth.googleUnauthorizedDomain": "هذا النطاق غير مصرح به لتسجيل الدخول عبر Google في Firebase.",
    "auth.googleUnavailable": "تسجيل الدخول عبر Google غير مُعد بعد.",
    "auth.haveAccount": "لديك حساب بالفعل؟",
    "auth.invalidResetLink": "رابط إعادة التعيين غير صالح أو منتهي الصلاحية.",
    "auth.joinUs": "انضم إلى Velaris Royal للاستفادة من المزايا الحصرية.",
    "auth.passwordTooShort": "يجب أن تكون كلمة المرور 6 أحرف على الأقل",
    "auth.passwordUpdated": "تم تحديث كلمة المرور بنجاح",
    "auth.resetDesc": "أدخل بريدك الإلكتروني لإعادة تعيين كلمة المرور.",
    "auth.resetEmailDeliveryFailed": "تعذر إرسال بريد إعادة التعيين حالياً.",
    "auth.resetEmailUnavailable": "بريد إعادة تعيين كلمة المرور غير مُعد بعد.",
    "auth.resetError": "فشل في إعادة تعيين كلمة المرور",
    "auth.resetPageDescription": "اختر كلمة مرور جديدة لحسابك في Velaris.",
    "auth.resetPassword": "إعادة تعيين كلمة المرور",
    "auth.resetToken": "رمز إعادة التعيين",
    "auth.resettingPassword": "جارٍ إعادة تعيين كلمة المرور...",
    "auth.sendResetLink": "إرسال رابط إعادة التعيين",
    "auth.signInRequired": "يرجى تسجيل الدخول لحفظ المفضلة.",
    "auth.signInWithNewPassword": "سجّل الدخول بكلمة المرور الجديدة للمتابعة.",
    "auth.welcomeBack": "مرحباً بعودتك! سجّل الدخول للمتابعة.",
    "badges.offer": "عرض",
    "badges.exclusive": "حصري",
    "badges.new": "جديد",
    "badges.discount": "خصم",
    "carDetail.basedOn": "استناداً إلى",
    "carDetail.browseAll": "تصفح جميع السيارات",
    "carDetail.clickToZoom": "اضغط للتكبير",
    "carDetail.comment": "التعليق",
    "carDetail.delivery": "توصيل واستلام مجاني",
    "carDetail.description": "الوصف",
    "carDetail.doors": "الأبواب",
    "carDetail.engine": "المحرك",
    "carDetail.features": "المزايا",
    "carDetail.featuresComingSoon": "معلومات المزايا ستتوفر قريباً.",
    "carDetail.from": "من",
    "carDetail.fuelType": "نوع الوقود",
    "carDetail.in": "في",
    "carDetail.inquiryFor": "استفسار عن",
    "carDetail.inquirySent": "تم إرسال الاستفسار بنجاح! سنتواصل معك قريباً.",
    "carDetail.insurance": "تأمين شامل",
    "carDetail.mileage": "200 كم يومياً",
    "carDetail.noDescription": "لا يوجد وصف متاح.",
    "carDetail.noReviews": "لا توجد مراجعات بعد. كن أول من يشارك تجربته.",
    "carDetail.notFound": "السيارة غير موجودة",
    "carDetail.power": "القوة",
    "carDetail.rating": "التقييم",
    "carDetail.rent": "استئجار",
    "carDetail.rentalRequirements": "أخبرنا بمتطلبات التأجير الخاصة بك...",
    "carDetail.req1": "رخصة قيادة إماراتية سارية أو تصريح قيادة دولي",
    "carDetail.req2": "الحد الأدنى للعمر: 25 سنة",
    "carDetail.req3": "وديعة تأمين",
    "carDetail.req4": "نسخة سارية من جواز السفر",
    "carDetail.req5": "تفويض بطاقة ائتمان",
    "carDetail.reviewError": "فشل في إرسال مراجعتك.",
    "carDetail.reviewSubmitted": "تم إرسال المراجعة بنجاح!",
    "carDetail.reviews": "المراجعات",
    "carDetail.reviewsCount": "مراجعة",
    "carDetail.roadside": "مساعدة على الطريق 24/7",
    "carDetail.seats": "المقاعد",
    "carDetail.shareExperience": "شارك تجربتك قبل الإرسال.",
    "carDetail.similar": "مشابهة",
    "carDetail.specs": "المواصفات",
    "carDetail.submitReview": "إرسال المراجعة",
    "carDetail.transmission": "ناقل الحركة",
    "carDetail.vehicles": "سيارات",
    "carDetail.whatsIncluded": "ما المشمول",
    "carDetail.writeReview": "اكتب مراجعة",
    "carDetail.yourReview": "مراجعتك",
    "common.linkCopied": "تم نسخ الرابط!",
    "contact.qrDescription": "امسح رمز QR هذا لفتح قناة التواصل المفضلة لدينا مباشرة على هاتفك. يمكنك لاحقاً استبدال الوجهة إذا أردته لصفحة هبوط أو بطاقة vCard قابلة للتنزيل.",
    "contact.qrEyebrow": "امسح وتواصل",
    "contact.qrHint": "وجهة رمز QR الحالية",
    "contact.qrTitle": "احفظ بياناتنا بمسحة واحدة",
    "contact.whatsappCarPrefill": "مرحباً! أرغب في استئجار {car}. يرجى تزويدي بمزيد من التفاصيل.",
    "contact.whatsappGeneralPrefill": "مرحباً! أنا مهتم باستئجار سيارة من Velaris Royal.",
    "cta.subtitle": "تصفح مجموعتنا المميزة واعثر على رحلتك المثالية. احجز الآن واستمتع بالتجربة الملكية.",
    "favorites.added": "تمت الإضافة إلى المفضلة.",
    "favorites.removed": "تمت الإزالة من المفضلة.",
    "favorites.updateError": "فشل تحديث المفضلة.",
    "footer.aboutFallback": "خدمات تأجير سيارات فاخرة في الإمارات. استمتع بالرفاهية والراحة مع أسطولنا الواسع من السيارات.",
    "footer.backToTop": "العودة للأعلى",
    "form.confirmPassword": "تأكيد كلمة المرور",
    "form.newPassword": "كلمة المرور الجديدة",
    "header.followUs": "تابعنا",
    "home.heroFallbackSubtitle": "اكتشف أرقى مجموعة من السيارات الفاخرة والرياضية والمميزة للإيجار في جميع أنحاء الإمارات.",
    "home.statsCarsAvailable": "سيارات متاحة",
    "home.statsHappyCustomers": "عملاء سعداء",
    "home.statsPartnerSuppliers": "موردون شركاء",
    "home.statsCitiesCovered": "مدن مشمولة",
    "home.featureInsuredTitle": "تأمين كامل",
    "home.featureInsuredDescription": "جميع السيارات مشمولة بتغطية تأمينية شاملة",
    "home.featureSupportTitle": "دعم 24/7",
    "home.featureSupportDescription": "دعم عملاء على مدار الساعة لراحتك",
    "home.featureFleetTitle": "أسطول مميز",
    "home.featureFleetDescription": "أحدث الطرازات من أشهر العلامات الفاخرة في العالم",
    "home.featurePricesTitle": "أفضل الأسعار",
    "home.featurePricesDescription": "أسعار تنافسية بدون رسوم مخفية",
    "listings.pageDescription": "تصفح واستأجر سيارات فاخرة ورياضية واقتصادية في دبي وأبوظبي وجميع أنحاء الإمارات. قارن الأسعار من أفضل الموردين واحجز فوراً.",
    "loyalty.tier.bronze": "برونزي",
    "loyalty.tier.silver": "فضي",
    "loyalty.tier.gold": "ذهبي",
    "loyalty.tier.platinum": "بلاتيني",
    "nav.offers": "العروض",
    "offers.browseFleet": "تحتاج خيارات أكثر؟",
    "offers.emptyDescription": "تحقق مرة أخرى قريباً أو تصفح كامل الأسطول لأحدث الإيجارات الفاخرة.",
    "offers.emptyEyebrow": "عرض",
    "offers.emptyTitle": "لا توجد عروض متاحة حالياً",
    "offers.heroDescription": "استكشف جميع الحملات النشطة، وقارن العروض محدودة الوقت، وانتقل مباشرة إلى الإيجارات الفاخرة المخفضة.",
    "offers.heroEyebrow": "عرض",
    "offers.heroTitle": "جميع العروض الحالية",
    "offers.loadError": "تعذر تحميل صفحة العروض حالياً.",
    "offers.loading": "جارٍ تحميل العروض...",
    "offers.pageDescription": "تصفح جميع عروض تأجير السيارات الفاخرة النشطة والخصومات والعروض محدودة الوقت من Velaris Royal.",
    "offers.pageTitle": "العروض | Velaris Royal Car Rental",
    "offers.sectionSubtitle": "متاحة الآن",
    "offers.sectionTitle": "جميع العروض",
    "offers.totalCars": "سيارات مخفضة",
    "offers.totalOffers": "عروض نشطة",
    "partners.becomePartnerDesc": "انضم إلى شبكة شركائنا المميزة وتواصل مع العملاء الباحثين عن تجارب سيارات فاخرة.",
    "partners.benefitQualityTitle": "ضمان الجودة",
    "partners.benefitQualityDescription": "يخضع جميع الشركاء لتدقيق صارم لضمان أعلى المعايير.",
    "partners.benefitCustomerFirstTitle": "العميل أولاً",
    "partners.benefitCustomerFirstDescription": "يشارك شركاؤنا التزامنا بتقديم خدمة عملاء استثنائية.",
    "partners.benefitNetworkTitle": "شبكة واسعة",
    "partners.benefitNetworkDescription": "الوصول إلى شبكة واسعة من الخدمات المميزة في أنحاء الإمارات.",
    "partners.benefitTrustedTitle": "تكاملات موثوقة",
    "partners.benefitTrustedDescription": "يتم إدارة شركاء التأمين والدفع والأعمال مباشرة من Odoo.",
    "partners.categoryCertification": "اعتماد",
    "partners.categoryCertificationDesc": "شهادات موثقة وعلامات ثقة تتم إدارتها من نظام Odoo CMS.",
    "partners.categoryInsurance": "شريك تأمين",
    "partners.categoryInsuranceDesc": "شركاء موثوقون للتغطية وإدارة المخاطر يدعمون رحلة التأجير.",
    "partners.categoryPartner": "شريك أعمال",
    "partners.categoryPartnerDesc": "شركاء الأعمال تتم إدارتهم من Odoo ويظهرون مباشرة على الموقع.",
    "partners.categoryPayment": "شريك دفع",
    "partners.categoryPaymentDesc": "مزودو دفع آمنون مدمجون في تجربة Velaris.",
    "partners.empty": "لم يتم العثور على شركاء نشطين في Odoo.",
    "partners.loadError": "تعذر تحميل قسم الشركاء من Odoo حالياً.",
    "partners.loading": "جارٍ تحميل الشركاء من Odoo...",
    "partners.managedInCms": "يُدار عبر Odoo CMS",
    "partners.pageDescription": "اكتشف شركاءنا الموثوقين في قطاع تأجير السيارات الفاخرة. وكالات وموردون ومقدمو خدمات مميزون في دبي والإمارات.",
    "pricing.pageDescription": "قارن أسعار تأجير السيارات الفاخرة في دبي والإمارات. أسعار يومية وأسبوعية وشهرية لجميع السيارات.",
    "profile.account": "الحساب",
    "profile.pointsBalance": "رصيد النقاط"
  },
  fr: {
    "auth.backToHome": "Retour à l’accueil",
    "auth.backToLogin": "Retour à la connexion",
    "auth.continueGoogle": "Continuer avec Google",
    "auth.enterEmail": "Veuillez saisir votre e-mail",
    "auth.enterResetToken": "Saisissez le code de réinitialisation reçu par e-mail.",
    "auth.fillAllFields": "Veuillez remplir tous les champs",
    "auth.googleInvalidToken": "Google n’a pas pu vérifier cette connexion. Veuillez réessayer.",
    "auth.googlePopupBlocked": "Votre navigateur a bloqué la fenêtre de connexion Google.",
    "auth.googleProviderUnavailable": "La connexion Google est indisponible pour le moment.",
    "auth.googleUnauthorizedDomain": "Ce domaine n’est pas autorisé pour la connexion Google dans Firebase.",
    "auth.googleUnavailable": "La connexion Google n’est pas encore configurée.",
    "auth.haveAccount": "Vous avez déjà un compte ?",
    "auth.invalidResetLink": "Ce lien de réinitialisation est invalide ou expiré.",
    "auth.joinUs": "Rejoignez Velaris Royal pour profiter d’avantages exclusifs.",
    "auth.passwordTooShort": "Le mot de passe doit comporter au moins 6 caractères",
    "auth.passwordUpdated": "Mot de passe mis à jour avec succès",
    "auth.resetDesc": "Saisissez votre e-mail pour réinitialiser votre mot de passe.",
    "auth.resetEmailDeliveryFailed": "Impossible d’envoyer l’e-mail de réinitialisation pour le moment.",
    "auth.resetEmailUnavailable": "L’e-mail de réinitialisation du mot de passe n’est pas encore configuré.",
    "auth.resetError": "Échec de la réinitialisation du mot de passe",
    "auth.resetPageDescription": "Choisissez un nouveau mot de passe pour votre compte Velaris.",
    "auth.resetPassword": "Réinitialiser le mot de passe",
    "auth.resetToken": "Code de réinitialisation",
    "auth.resettingPassword": "Réinitialisation du mot de passe...",
    "auth.sendResetLink": "Envoyer le lien de réinitialisation",
    "auth.signInRequired": "Veuillez vous connecter pour enregistrer vos favoris.",
    "auth.signInWithNewPassword": "Connectez-vous avec votre nouveau mot de passe pour continuer.",
    "auth.welcomeBack": "Bon retour ! Connectez-vous pour continuer.",
    "badges.offer": "Offre",
    "badges.exclusive": "Exclusif",
    "badges.new": "Nouveau",
    "badges.discount": "Remise",
    "carDetail.basedOn": "Sur la base de",
    "carDetail.browseAll": "Voir toutes les voitures",
    "carDetail.clickToZoom": "Cliquer pour zoomer",
    "carDetail.comment": "Commentaire",
    "carDetail.delivery": "Livraison et reprise gratuites",
    "carDetail.description": "Description",
    "carDetail.doors": "Portes",
    "carDetail.engine": "Moteur",
    "carDetail.features": "Équipements",
    "carDetail.featuresComingSoon": "Les informations sur les équipements arrivent bientôt.",
    "carDetail.from": "à partir de",
    "carDetail.fuelType": "Carburant",
    "carDetail.in": "à",
    "carDetail.inquiryFor": "Demande pour",
    "carDetail.inquirySent": "Demande envoyée avec succès ! Nous vous contacterons bientôt.",
    "carDetail.insurance": "Assurance tous risques",
    "carDetail.mileage": "200 km par jour",
    "carDetail.noDescription": "Aucune description disponible.",
    "carDetail.noReviews": "Aucun avis pour le moment. Soyez le premier à partager votre expérience.",
    "carDetail.notFound": "Voiture introuvable",
    "carDetail.power": "Puissance",
    "carDetail.rating": "Note",
    "carDetail.rent": "Louer",
    "carDetail.rentalRequirements": "Parlez-nous de vos besoins de location...",
    "carDetail.req1": "Permis de conduire EAU valide ou permis international",
    "carDetail.req2": "Âge minimum : 25 ans",
    "carDetail.req3": "Dépôt de garantie",
    "carDetail.req4": "Copie valide du passeport",
    "carDetail.req5": "Autorisation de carte bancaire",
    "carDetail.reviewError": "Échec de l’envoi de votre avis.",
    "carDetail.reviewSubmitted": "Avis envoyé avec succès !",
    "carDetail.reviews": "Avis",
    "carDetail.reviewsCount": "avis",
    "carDetail.roadside": "Assistance routière 24h/24 et 7j/7",
    "carDetail.seats": "Places",
    "carDetail.shareExperience": "Partagez votre expérience avant l’envoi.",
    "carDetail.similar": "Similaires",
    "carDetail.specs": "Caractéristiques",
    "carDetail.submitReview": "Envoyer l’avis",
    "carDetail.transmission": "Transmission",
    "carDetail.vehicles": "Véhicules",
    "carDetail.whatsIncluded": "Ce qui est inclus",
    "carDetail.writeReview": "Rédiger un avis",
    "carDetail.yourReview": "Votre avis",
    "common.linkCopied": "Lien copié dans le presse-papiers !",
    "contact.qrDescription": "Scannez ce QR code pour ouvrir instantanément notre canal de contact préféré sur votre téléphone. Vous pourrez ensuite remplacer cette destination par une page dédiée ou une vCard téléchargeable.",
    "contact.qrEyebrow": "Scanner et contacter",
    "contact.qrHint": "Destination actuelle du QR code",
    "contact.qrTitle": "Enregistrez nos coordonnées en un scan",
    "contact.whatsappCarPrefill": "Bonjour ! Je suis intéressé(e) par la location de {car}. Merci de m’envoyer plus de détails.",
    "contact.whatsappGeneralPrefill": "Bonjour ! Je suis intéressé(e) par la location d’une voiture chez Velaris Royal.",
    "cta.subtitle": "Parcourez notre collection premium et trouvez le véhicule idéal. Réservez dès maintenant et profitez d’un service royal.",
    "favorites.added": "Ajouté aux favoris.",
    "favorites.removed": "Retiré des favoris.",
    "favorites.updateError": "Échec de la mise à jour des favoris.",
    "footer.aboutFallback": "Services de location de voitures premium aux Émirats arabes unis. Profitez du luxe et du confort avec notre vaste flotte de véhicules.",
    "footer.backToTop": "Retour en haut",
    "form.confirmPassword": "Confirmer le mot de passe",
    "form.newPassword": "Nouveau mot de passe",
    "header.followUs": "Suivez-nous",
    "home.heroFallbackSubtitle": "Découvrez la plus belle collection de véhicules de luxe, sportifs et premium à louer à travers les Émirats arabes unis.",
    "home.statsCarsAvailable": "Voitures disponibles",
    "home.statsHappyCustomers": "Clients satisfaits",
    "home.statsPartnerSuppliers": "Partenaires fournisseurs",
    "home.statsCitiesCovered": "Villes couvertes",
    "home.featureInsuredTitle": "Assurance complète",
    "home.featureInsuredDescription": "Tous les véhicules sont couverts par une assurance complète",
    "home.featureSupportTitle": "Assistance 24/7",
    "home.featureSupportDescription": "Un service client disponible à toute heure pour votre confort",
    "home.featureFleetTitle": "Flotte premium",
    "home.featureFleetDescription": "Les derniers modèles des plus grandes marques de luxe",
    "home.featurePricesTitle": "Meilleurs prix",
    "home.featurePricesDescription": "Des tarifs compétitifs sans frais cachés",
    "listings.pageDescription": "Parcourez et louez des voitures de luxe, sportives et économiques à Dubaï, Abu Dhabi et dans tout les Émirats. Comparez les prix des meilleurs fournisseurs et réservez instantanément.",
    "loyalty.tier.bronze": "Bronze",
    "loyalty.tier.silver": "Argent",
    "loyalty.tier.gold": "Or",
    "loyalty.tier.platinum": "Platine",
    "nav.offers": "Offres",
    "offers.browseFleet": "Besoin de plus d’options ?",
    "offers.emptyDescription": "Revenez bientôt ou parcourez toute la flotte pour découvrir les dernières locations de luxe.",
    "offers.emptyEyebrow": "Offre",
    "offers.emptyTitle": "Aucune offre disponible pour le moment",
    "offers.heroDescription": "Explorez chaque campagne active, comparez les offres à durée limitée et accédez directement aux locations de luxe à prix réduit.",
    "offers.heroEyebrow": "Offre",
    "offers.heroTitle": "Toutes les offres actuelles",
    "offers.loadError": "La page des offres n’a pas pu être chargée pour le moment.",
    "offers.loading": "Chargement des offres...",
    "offers.pageDescription": "Parcourez toutes les offres actives, promotions et remises de location de voitures de luxe de Velaris Royal.",
    "offers.pageTitle": "Offres | Velaris Royal Car Rental",
    "offers.sectionSubtitle": "Disponibles maintenant",
    "offers.sectionTitle": "Toutes les offres",
    "offers.totalCars": "Voitures en promotion",
    "offers.totalOffers": "Offres actives",
    "partners.becomePartnerDesc": "Rejoignez notre réseau de partenaires premium et entrez en contact avec une clientèle à la recherche d’expériences automobiles de luxe.",
    "partners.benefitQualityTitle": "Assurance qualité",
    "partners.benefitQualityDescription": "Tous les partenaires passent par une sélection rigoureuse pour garantir les meilleurs standards.",
    "partners.benefitCustomerFirstTitle": "Le client d’abord",
    "partners.benefitCustomerFirstDescription": "Nos partenaires partagent notre engagement envers un service client exceptionnel.",
    "partners.benefitNetworkTitle": "Réseau étendu",
    "partners.benefitNetworkDescription": "Accédez à un vaste réseau de services premium à travers les Émirats.",
    "partners.benefitTrustedTitle": "Intégrations fiables",
    "partners.benefitTrustedDescription": "Les partenaires assurance, paiement et business sont gérés directement depuis Odoo.",
    "partners.categoryCertification": "Certification",
    "partners.categoryCertificationDesc": "Certifications vérifiées et éléments de confiance gérés depuis le CMS Odoo.",
    "partners.categoryInsurance": "Partenaire assurance",
    "partners.categoryInsuranceDesc": "Des partenaires fiables en couverture et gestion des risques pour accompagner le parcours de location.",
    "partners.categoryPartner": "Partenaire commercial",
    "partners.categoryPartnerDesc": "Des partenaires commerciaux gérés dans Odoo et affichés directement sur le site.",
    "partners.categoryPayment": "Partenaire de paiement",
    "partners.categoryPaymentDesc": "Des fournisseurs de paiement sécurisés intégrés à l’expérience Velaris.",
    "partners.empty": "Aucun partenaire actif n’a été trouvé dans Odoo.",
    "partners.loadError": "La section partenaires n’a pas pu être chargée depuis Odoo pour le moment.",
    "partners.loading": "Chargement des partenaires depuis Odoo...",
    "partners.managedInCms": "Géré dans le CMS Odoo",
    "partners.pageDescription": "Découvrez nos partenaires de confiance dans la location de voitures de luxe. Concessionnaires, fournisseurs et prestataires premium à Dubaï et aux Émirats.",
    "pricing.pageDescription": "Comparez les tarifs de location de voitures de luxe à Dubaï et aux Émirats. Tarifs journaliers, hebdomadaires et mensuels pour tous les véhicules.",
    "profile.account": "Compte",
    "profile.pointsBalance": "Solde de points"
  },
  de: {
    "auth.backToHome": "Zur Startseite",
    "auth.backToLogin": "Zurück zur Anmeldung",
    "auth.continueGoogle": "Mit Google fortfahren",
    "auth.enterEmail": "Bitte geben Sie Ihre E-Mail-Adresse ein",
    "auth.enterResetToken": "Geben Sie den Rücksetzcode aus Ihrer E-Mail ein.",
    "auth.fillAllFields": "Bitte füllen Sie alle Felder aus",
    "auth.googleInvalidToken": "Google konnte diese Anmeldung nicht verifizieren. Bitte versuchen Sie es erneut.",
    "auth.googlePopupBlocked": "Ihr Browser hat das Google-Anmeldefenster blockiert.",
    "auth.googleProviderUnavailable": "Google-Anmeldung ist derzeit nicht verfügbar.",
    "auth.googleUnauthorizedDomain": "Diese Domain ist für die Google-Anmeldung in Firebase nicht autorisiert.",
    "auth.googleUnavailable": "Google-Anmeldung ist noch nicht eingerichtet.",
    "auth.haveAccount": "Haben Sie bereits ein Konto?",
    "auth.invalidResetLink": "Dieser Zurücksetzungslink ist ungültig oder abgelaufen.",
    "auth.joinUs": "Werden Sie Teil von Velaris Royal und sichern Sie sich exklusive Vorteile.",
    "auth.passwordTooShort": "Das Passwort muss mindestens 6 Zeichen lang sein",
    "auth.passwordUpdated": "Passwort erfolgreich aktualisiert",
    "auth.resetDesc": "Geben Sie Ihre E-Mail-Adresse ein, um Ihr Passwort zurückzusetzen.",
    "auth.resetEmailDeliveryFailed": "Die Reset-E-Mail kann momentan nicht gesendet werden.",
    "auth.resetEmailUnavailable": "Die Passwort-Reset-E-Mail ist noch nicht eingerichtet.",
    "auth.resetError": "Passwort konnte nicht zurückgesetzt werden",
    "auth.resetPageDescription": "Wählen Sie ein neues Passwort für Ihr Velaris-Konto.",
    "auth.resetPassword": "Passwort zurücksetzen",
    "auth.resetToken": "Reset-Code",
    "auth.resettingPassword": "Passwort wird zurückgesetzt...",
    "auth.sendResetLink": "Reset-Link senden",
    "auth.signInRequired": "Bitte melden Sie sich an, um Favoriten zu speichern.",
    "auth.signInWithNewPassword": "Melden Sie sich mit Ihrem neuen Passwort an, um fortzufahren.",
    "auth.welcomeBack": "Willkommen zurück! Bitte melden Sie sich an, um fortzufahren.",
    "badges.offer": "Angebot",
    "badges.exclusive": "Exklusiv",
    "badges.new": "Neu",
    "badges.discount": "Rabatt",
    "carDetail.basedOn": "Basierend auf",
    "carDetail.browseAll": "Alle Fahrzeuge ansehen",
    "carDetail.clickToZoom": "Zum Zoomen klicken",
    "carDetail.comment": "Kommentar",
    "carDetail.delivery": "Kostenlose Lieferung und Abholung",
    "carDetail.description": "Beschreibung",
    "carDetail.doors": "Türen",
    "carDetail.engine": "Motor",
    "carDetail.features": "Ausstattung",
    "carDetail.featuresComingSoon": "Informationen zur Ausstattung folgen bald.",
    "carDetail.from": "ab",
    "carDetail.fuelType": "Kraftstoffart",
    "carDetail.in": "in",
    "carDetail.inquiryFor": "Anfrage für",
    "carDetail.inquirySent": "Anfrage erfolgreich gesendet! Wir melden uns bald bei Ihnen.",
    "carDetail.insurance": "Vollkaskoversicherung",
    "carDetail.mileage": "200 km pro Tag",
    "carDetail.noDescription": "Keine Beschreibung verfügbar.",
    "carDetail.noReviews": "Noch keine Bewertungen. Seien Sie die erste Person, die ihre Erfahrung teilt.",
    "carDetail.notFound": "Fahrzeug nicht gefunden",
    "carDetail.power": "Leistung",
    "carDetail.rating": "Bewertung",
    "carDetail.rent": "Mieten",
    "carDetail.rentalRequirements": "Teilen Sie uns Ihre Mietanforderungen mit...",
    "carDetail.req1": "Gültiger UAE-Führerschein oder internationaler Führerschein",
    "carDetail.req2": "Mindestalter: 25 Jahre",
    "carDetail.req3": "Kaution",
    "carDetail.req4": "Gültige Passkopie",
    "carDetail.req5": "Kreditkartenautorisierung",
    "carDetail.reviewError": "Ihre Bewertung konnte nicht gesendet werden.",
    "carDetail.reviewSubmitted": "Bewertung erfolgreich gesendet!",
    "carDetail.reviews": "Bewertungen",
    "carDetail.reviewsCount": "Bewertungen",
    "carDetail.roadside": "24/7 Pannenhilfe",
    "carDetail.seats": "Sitze",
    "carDetail.shareExperience": "Teilen Sie Ihre Erfahrung vor dem Senden.",
    "carDetail.similar": "Ähnliche",
    "carDetail.specs": "Spezifikationen",
    "carDetail.submitReview": "Bewertung senden",
    "carDetail.transmission": "Getriebe",
    "carDetail.vehicles": "Fahrzeuge",
    "carDetail.whatsIncluded": "Was enthalten ist",
    "carDetail.writeReview": "Bewertung schreiben",
    "carDetail.yourReview": "Ihre Bewertung",
    "common.linkCopied": "Link in die Zwischenablage kopiert!",
    "contact.qrDescription": "Scannen Sie diesen QR-Code, um unseren bevorzugten Kontaktkanal sofort auf Ihrem Telefon zu öffnen. Später können Sie das Ziel auf eine Landingpage oder herunterladbare vCard ändern.",
    "contact.qrEyebrow": "Scannen & verbinden",
    "contact.qrHint": "Aktuelles QR-Ziel",
    "contact.qrTitle": "Speichern Sie unsere Daten mit einem Scan",
    "contact.whatsappCarPrefill": "Hallo! Ich interessiere mich für die Miete von {car}. Bitte senden Sie mir weitere Details.",
    "contact.whatsappGeneralPrefill": "Hallo! Ich interessiere mich für ein Mietfahrzeug von Velaris Royal.",
    "cta.subtitle": "Durchsuchen Sie unsere Premium-Kollektion und finden Sie Ihr perfektes Fahrzeug. Buchen Sie jetzt und genießen Sie königlichen Service.",
    "favorites.added": "Zu Favoriten hinzugefügt.",
    "favorites.removed": "Aus Favoriten entfernt.",
    "favorites.updateError": "Favoriten konnten nicht aktualisiert werden.",
    "footer.aboutFallback": "Premium-Autovermietung in den Vereinigten Arabischen Emiraten. Erleben Sie Luxus und Komfort mit unserer umfangreichen Fahrzeugflotte.",
    "footer.backToTop": "Nach oben",
    "form.confirmPassword": "Passwort bestätigen",
    "form.newPassword": "Neues Passwort",
    "header.followUs": "Folgen Sie uns",
    "home.heroFallbackSubtitle": "Entdecken Sie die beste Auswahl an Luxus-, Sport- und Premiumfahrzeugen zur Miete in den gesamten VAE.",
    "home.statsCarsAvailable": "Verfügbare Fahrzeuge",
    "home.statsHappyCustomers": "Zufriedene Kunden",
    "home.statsPartnerSuppliers": "Partneranbieter",
    "home.statsCitiesCovered": "Abgedeckte Städte",
    "home.featureInsuredTitle": "Voll versichert",
    "home.featureInsuredDescription": "Alle Fahrzeuge sind umfassend versichert",
    "home.featureSupportTitle": "24/7 Support",
    "home.featureSupportDescription": "Rund-um-die-Uhr-Kundensupport für Ihren Komfort",
    "home.featureFleetTitle": "Premium-Flotte",
    "home.featureFleetDescription": "Neueste Modelle weltbekannter Luxusmarken",
    "home.featurePricesTitle": "Beste Preise",
    "home.featurePricesDescription": "Wettbewerbsfähige Preise ohne versteckte Gebühren",
    "listings.pageDescription": "Durchsuchen und mieten Sie Luxus-, Sport- und Economy-Fahrzeuge in Dubai, Abu Dhabi und den gesamten VAE. Vergleichen Sie Preise führender Anbieter und buchen Sie sofort.",
    "loyalty.tier.bronze": "Bronze",
    "loyalty.tier.silver": "Silber",
    "loyalty.tier.gold": "Gold",
    "loyalty.tier.platinum": "Platin",
    "nav.offers": "Angebote",
    "offers.browseFleet": "Mehr Optionen benötigt?",
    "offers.emptyDescription": "Schauen Sie bald wieder vorbei oder durchsuchen Sie die gesamte Flotte nach den neuesten Luxusmieten.",
    "offers.emptyEyebrow": "Angebot",
    "offers.emptyTitle": "Derzeit sind keine Angebote verfügbar",
    "offers.heroDescription": "Entdecken Sie alle aktiven Kampagnen, vergleichen Sie zeitlich begrenzte Angebote und springen Sie direkt zu reduzierten Luxusmieten.",
    "offers.heroEyebrow": "Angebot",
    "offers.heroTitle": "Alle aktuellen Angebote",
    "offers.loadError": "Die Angebotsseite konnte derzeit nicht geladen werden.",
    "offers.loading": "Angebote werden geladen...",
    "offers.pageDescription": "Durchsuchen Sie alle aktiven Luxus-Autovermietungsangebote, Aktionen und zeitlich begrenzten Deals von Velaris Royal.",
    "offers.pageTitle": "Angebote | Velaris Royal Car Rental",
    "offers.sectionSubtitle": "Jetzt verfügbar",
    "offers.sectionTitle": "Alle Angebote",
    "offers.totalCars": "Fahrzeuge mit Rabatt",
    "offers.totalOffers": "Aktive Angebote",
    "partners.becomePartnerDesc": "Werden Sie Teil unseres Premium-Partnernetzwerks und erreichen Sie anspruchsvolle Kunden, die nach luxuriösen Fahrerlebnissen suchen.",
    "partners.benefitQualityTitle": "Qualitätssicherung",
    "partners.benefitQualityDescription": "Alle Partner werden streng geprüft, um höchste Standards sicherzustellen.",
    "partners.benefitCustomerFirstTitle": "Kunde zuerst",
    "partners.benefitCustomerFirstDescription": "Unsere Partner teilen unser Engagement für außergewöhnlichen Kundenservice.",
    "partners.benefitNetworkTitle": "Großes Netzwerk",
    "partners.benefitNetworkDescription": "Zugang zu einem umfangreichen Netzwerk an Premium-Services in den VAE.",
    "partners.benefitTrustedTitle": "Vertrauenswürdige Integrationen",
    "partners.benefitTrustedDescription": "Versicherungs-, Zahlungs- und Geschäftspartner werden direkt in Odoo verwaltet.",
    "partners.categoryCertification": "Zertifizierung",
    "partners.categoryCertificationDesc": "Verifizierte Zertifizierungen und Vertrauenssignale, die im Odoo CMS gepflegt werden.",
    "partners.categoryInsurance": "Versicherungspartner",
    "partners.categoryInsuranceDesc": "Zuverlässige Partner für Deckung und Risikomanagement entlang der Mietreise.",
    "partners.categoryPartner": "Geschäftspartner",
    "partners.categoryPartnerDesc": "Geschäftspartner werden in Odoo verwaltet und direkt auf der Website angezeigt.",
    "partners.categoryPayment": "Zahlungspartner",
    "partners.categoryPaymentDesc": "Sichere Zahlungsanbieter, die in das Velaris-Erlebnis integriert sind.",
    "partners.empty": "In Odoo wurden keine aktiven Partner gefunden.",
    "partners.loadError": "Der Partnerbereich konnte derzeit nicht aus Odoo geladen werden.",
    "partners.loading": "Partner werden aus Odoo geladen...",
    "partners.managedInCms": "Im Odoo CMS verwaltet",
    "partners.pageDescription": "Entdecken Sie unsere vertrauenswürdigen Partner in der Luxus-Autovermietung. Premium-Händler, Lieferanten und Dienstleister in Dubai und den VAE.",
    "pricing.pageDescription": "Vergleichen Sie Preise für Luxus-Autovermietungen in Dubai und den VAE. Tages-, Wochen- und Monatspreise für alle Fahrzeuge.",
    "profile.account": "Konto",
    "profile.pointsBalance": "Punktestand"
  },
  ru: {
    "auth.backToHome": "Назад на главную",
    "auth.backToLogin": "Назад ко входу",
    "auth.continueGoogle": "Продолжить через Google",
    "auth.enterEmail": "Пожалуйста, введите ваш e-mail",
    "auth.enterResetToken": "Введите код сброса из письма.",
    "auth.fillAllFields": "Пожалуйста, заполните все поля",
    "auth.googleInvalidToken": "Google не смог подтвердить этот вход. Попробуйте ещё раз.",
    "auth.googlePopupBlocked": "Браузер заблокировал всплывающее окно входа через Google.",
    "auth.googleProviderUnavailable": "Вход через Google сейчас недоступен.",
    "auth.googleUnauthorizedDomain": "Этот домен не авторизован для входа через Google в Firebase.",
    "auth.googleUnavailable": "Вход через Google ещё не настроен.",
    "auth.haveAccount": "У вас уже есть аккаунт?",
    "auth.invalidResetLink": "Ссылка для сброса недействительна или срок её действия истёк.",
    "auth.joinUs": "Присоединяйтесь к Velaris Royal и получите эксклюзивные преимущества.",
    "auth.passwordTooShort": "Пароль должен содержать не менее 6 символов",
    "auth.passwordUpdated": "Пароль успешно обновлён",
    "auth.resetDesc": "Введите ваш e-mail, чтобы сбросить пароль.",
    "auth.resetEmailDeliveryFailed": "Сейчас не удалось отправить письмо для сброса пароля.",
    "auth.resetEmailUnavailable": "Письмо для сброса пароля ещё не настроено.",
    "auth.resetError": "Не удалось сбросить пароль",
    "auth.resetPageDescription": "Выберите новый пароль для аккаунта Velaris.",
    "auth.resetPassword": "Сбросить пароль",
    "auth.resetToken": "Код сброса",
    "auth.resettingPassword": "Пароль сбрасывается...",
    "auth.sendResetLink": "Отправить ссылку для сброса",
    "auth.signInRequired": "Пожалуйста, войдите, чтобы сохранять избранное.",
    "auth.signInWithNewPassword": "Войдите с новым паролем, чтобы продолжить.",
    "auth.welcomeBack": "С возвращением! Войдите, чтобы продолжить.",
    "badges.offer": "Предложение",
    "badges.exclusive": "Эксклюзив",
    "badges.new": "Новинка",
    "badges.discount": "Скидка",
    "carDetail.basedOn": "На основе",
    "carDetail.browseAll": "Посмотреть все автомобили",
    "carDetail.clickToZoom": "Нажмите для увеличения",
    "carDetail.comment": "Комментарий",
    "carDetail.delivery": "Бесплатная доставка и возврат",
    "carDetail.description": "Описание",
    "carDetail.doors": "Двери",
    "carDetail.engine": "Двигатель",
    "carDetail.features": "Особенности",
    "carDetail.featuresComingSoon": "Информация об особенностях скоро появится.",
    "carDetail.from": "от",
    "carDetail.fuelType": "Тип топлива",
    "carDetail.in": "в",
    "carDetail.inquiryFor": "Запрос по",
    "carDetail.inquirySent": "Запрос успешно отправлен! Мы скоро с вами свяжемся.",
    "carDetail.insurance": "Полная страховка",
    "carDetail.mileage": "200 км в день",
    "carDetail.noDescription": "Описание отсутствует.",
    "carDetail.noReviews": "Пока нет отзывов. Станьте первым, кто поделится впечатлениями.",
    "carDetail.notFound": "Автомобиль не найден",
    "carDetail.power": "Мощность",
    "carDetail.rating": "Рейтинг",
    "carDetail.rent": "Арендовать",
    "carDetail.rentalRequirements": "Расскажите нам о ваших требованиях к аренде...",
    "carDetail.req1": "Действующее водительское удостоверение ОАЭ или международные права",
    "carDetail.req2": "Минимальный возраст: 25 лет",
    "carDetail.req3": "Гарантийный депозит",
    "carDetail.req4": "Действующая копия паспорта",
    "carDetail.req5": "Авторизация банковской карты",
    "carDetail.reviewError": "Не удалось отправить ваш отзыв.",
    "carDetail.reviewSubmitted": "Отзыв успешно отправлен!",
    "carDetail.reviews": "Отзывы",
    "carDetail.reviewsCount": "отзывов",
    "carDetail.roadside": "Помощь на дороге 24/7",
    "carDetail.seats": "Места",
    "carDetail.shareExperience": "Поделитесь опытом перед отправкой.",
    "carDetail.similar": "Похожие",
    "carDetail.specs": "Характеристики",
    "carDetail.submitReview": "Отправить отзыв",
    "carDetail.transmission": "Трансмиссия",
    "carDetail.vehicles": "Автомобили",
    "carDetail.whatsIncluded": "Что включено",
    "carDetail.writeReview": "Написать отзыв",
    "carDetail.yourReview": "Ваш отзыв",
    "common.linkCopied": "Ссылка скопирована в буфер обмена!",
    "contact.qrDescription": "Отсканируйте этот QR-код, чтобы сразу открыть наш предпочтительный канал связи на телефоне. Позже вы сможете заменить адрес на лендинг или загружаемую vCard.",
    "contact.qrEyebrow": "Сканируйте и связывайтесь",
    "contact.qrHint": "Текущий адрес QR-кода",
    "contact.qrTitle": "Сохраните наши контакты одним сканированием",
    "contact.whatsappCarPrefill": "Здравствуйте! Меня интересует аренда {car}. Пожалуйста, отправьте больше деталей.",
    "contact.whatsappGeneralPrefill": "Здравствуйте! Меня интересует аренда автомобиля в Velaris Royal.",
    "cta.subtitle": "Изучите нашу премиальную коллекцию и найдите идеальный автомобиль. Бронируйте сейчас и наслаждайтесь королевским сервисом.",
    "favorites.added": "Добавлено в избранное.",
    "favorites.removed": "Удалено из избранного.",
    "favorites.updateError": "Не удалось обновить избранное.",
    "footer.aboutFallback": "Премиальный прокат автомобилей в ОАЭ. Ощутите роскошь и комфорт с нашим обширным автопарком.",
    "footer.backToTop": "Наверх",
    "form.confirmPassword": "Подтвердите пароль",
    "form.newPassword": "Новый пароль",
    "header.followUs": "Подписывайтесь",
    "home.heroFallbackSubtitle": "Откройте для себя лучшую коллекцию роскошных, спортивных и премиальных автомобилей для аренды по всем ОАЭ.",
    "home.statsCarsAvailable": "Доступные автомобили",
    "home.statsHappyCustomers": "Довольные клиенты",
    "home.statsPartnerSuppliers": "Партнёры-поставщики",
    "home.statsCitiesCovered": "Охваченные города",
    "home.featureInsuredTitle": "Полная страховка",
    "home.featureInsuredDescription": "Все автомобили застрахованы по полной программе",
    "home.featureSupportTitle": "Поддержка 24/7",
    "home.featureSupportDescription": "Круглосуточная поддержка клиентов для вашего удобства",
    "home.featureFleetTitle": "Премиальный автопарк",
    "home.featureFleetDescription": "Последние модели от всемирно известных люксовых брендов",
    "home.featurePricesTitle": "Лучшие цены",
    "home.featurePricesDescription": "Конкурентные тарифы без скрытых платежей",
    "listings.pageDescription": "Выбирайте и арендуйте роскошные, спортивные и экономичные автомобили в Дубае, Абу-Даби и по всем ОАЭ. Сравнивайте цены ведущих поставщиков и бронируйте мгновенно.",
    "loyalty.tier.bronze": "Бронзовый",
    "loyalty.tier.silver": "Серебряный",
    "loyalty.tier.gold": "Золотой",
    "loyalty.tier.platinum": "Платиновый",
    "nav.offers": "Предложения",
    "offers.browseFleet": "Нужно больше вариантов?",
    "offers.emptyDescription": "Проверьте страницу позже или просмотрите весь автопарк, чтобы увидеть последние предложения по аренде люксовых авто.",
    "offers.emptyEyebrow": "Предложение",
    "offers.emptyTitle": "Сейчас нет доступных предложений",
    "offers.heroDescription": "Изучайте все активные кампании, сравнивайте ограниченные по времени предложения и сразу переходите к аренде люксовых автомобилей со скидкой.",
    "offers.heroEyebrow": "Предложение",
    "offers.heroTitle": "Все текущие предложения",
    "offers.loadError": "Страницу предложений сейчас не удалось загрузить.",
    "offers.loading": "Загрузка предложений...",
    "offers.pageDescription": "Просматривайте все активные предложения, акции и ограниченные по времени скидки на аренду люксовых автомобилей от Velaris Royal.",
    "offers.pageTitle": "Предложения | Velaris Royal Car Rental",
    "offers.sectionSubtitle": "Доступно сейчас",
    "offers.sectionTitle": "Все предложения",
    "offers.totalCars": "Автомобили со скидкой",
    "offers.totalOffers": "Активные предложения",
    "partners.becomePartnerDesc": "Присоединяйтесь к нашей сети премиальных партнёров и выходите на взыскательных клиентов, ищущих роскошные автомобильные впечатления.",
    "partners.benefitQualityTitle": "Гарантия качества",
    "partners.benefitQualityDescription": "Все партнёры проходят строгую проверку, чтобы соответствовать самым высоким стандартам.",
    "partners.benefitCustomerFirstTitle": "Клиент прежде всего",
    "partners.benefitCustomerFirstDescription": "Наши партнёры разделяют нашу приверженность исключительному клиентскому сервису.",
    "partners.benefitNetworkTitle": "Широкая сеть",
    "partners.benefitNetworkDescription": "Доступ к обширной сети премиальных услуг по всем ОАЭ.",
    "partners.benefitTrustedTitle": "Надёжные интеграции",
    "partners.benefitTrustedDescription": "Страховые, платёжные и бизнес-партнёры управляются напрямую из Odoo.",
    "partners.categoryCertification": "Сертификация",
    "partners.categoryCertificationDesc": "Подтверждённые сертификаты и сигналы доверия, поддерживаемые в Odoo CMS.",
    "partners.categoryInsurance": "Страховой партнёр",
    "partners.categoryInsuranceDesc": "Надёжные партнёры по страхованию и управлению рисками, поддерживающие путь аренды.",
    "partners.categoryPartner": "Бизнес-партнёр",
    "partners.categoryPartnerDesc": "Бизнес-партнёры управляются в Odoo и напрямую показываются на сайте.",
    "partners.categoryPayment": "Платёжный партнёр",
    "partners.categoryPaymentDesc": "Безопасные платёжные провайдеры, встроенные в клиентский опыт Velaris.",
    "partners.empty": "В Odoo не найдено активных партнёров.",
    "partners.loadError": "Раздел партнёров сейчас не удалось загрузить из Odoo.",
    "partners.loading": "Загрузка партнёров из Odoo...",
    "partners.managedInCms": "Управляется в Odoo CMS",
    "partners.pageDescription": "Познакомьтесь с нашими надёжными партнёрами в сфере аренды люксовых автомобилей. Премиальные дилеры, поставщики и сервисные компании в Дубае и ОАЭ.",
    "pricing.pageDescription": "Сравните цены на аренду люксовых автомобилей в Дубае и ОАЭ. Дневные, недельные и месячные тарифы для всех автомобилей.",
    "profile.account": "Аккаунт",
    "profile.pointsBalance": "Баланс баллов"
  },
};
